import React, { useEffect, useMemo, useState } from "react";
import api from "../../../services/api";
import { useAuth } from "../../../context/AuthContext";
import { useTheme } from "@mui/material/styles";

type PO = {
  status: string;
  items?: Array<{ quantity: number; received?: number }>;
};

const DashboardWidgets: React.FC = () => {
  const { token } = useAuth();
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";
  const [pos, setPos] = useState<PO[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    api
      .get("/inventory/po/all", { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setPos(res.data || []))
      .catch(() => setPos([]))
      .finally(() => setLoading(false));
  }, [token]);

  const { pendingCount, itemsToReceive } = useMemo(() => {
    const open = (pos || []).filter(
      (p) => p.status !== "received" && p.status !== "cancelled"
    );
    const pending = open.length;
    const toReceive = open.reduce((sum, p) => {
      const lines = Array.isArray(p.items) ? p.items : [];
      return (
        sum +
        lines.reduce(
          (s, l) => s + Math.max(0, (Number(l.quantity) || 0) - (Number(l.received) || 0)),
          0
        )
      );
    }, 0);
    return { pendingCount: pending, itemsToReceive: toReceive };
  }, [pos]);

  return (
    <div className="grid grid-cols-2 gap-4 mb-6">
      <div className={`p-4 rounded shadow text-center border ${dark ? 'bg-slate-900 border-slate-700' : 'bg-white border-slate-200'}`}>
        <div className="text-3xl font-extrabold text-blue-300">
          {loading ? "…" : pendingCount}
        </div>
        <div className="text-sm text-slate-400">Pending Purchase Orders</div>
      </div>
      <div className={`p-4 rounded shadow text-center border ${dark ? 'bg-slate-900 border-slate-700' : 'bg-white border-slate-200'}`}>
        <div className="text-3xl font-extrabold text-emerald-300">
          {loading ? "…" : itemsToReceive}
        </div>
        <div className="text-sm text-slate-400">Items to Receive</div>
      </div>
    </div>
  );
};

export default DashboardWidgets;
